import { Component, inject, OnInit } from '@angular/core';
import { Browser, UserAgentService } from '@lc/core';
import { RouterLink } from '@angular/router';
import { BrandService } from '@lc/core/lib/services/brand.service';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'lc-browser-support',
  templateUrl: './browser-support.component.html',
  styleUrls: ['./browser-support.component.scss'],
  imports: [RouterLink, NgOptimizedImage],
})
export class BrowserSupportComponent implements OnInit {
  private userAgentService = inject(UserAgentService);

  public os: string;
  public osVersion: string;
  public browser: string;
  public browserVersion: string;
  public isCompliant: boolean;

  public supportedBrowsers: Browser[];
  readonly brandService = inject(BrandService);
  readonly applicationName = this.brandService.applicationName();
  readonly logo = this.brandService.brandLogo();

  ngOnInit() {
    // user's info
    this.os = this.userAgentService.getOs();
    this.osVersion = this.userAgentService.getOsVersion();
    this.browser = this.userAgentService.getBrowser();
    this.browserVersion = this.userAgentService.getBrowserVersion();
    this.isCompliant = this.userAgentService.isCompliant();

    // supported user agents
    this.supportedBrowsers = this.userAgentService.getSupportedBrowsers(this.os);
  }
}
